"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFitToWidth = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * A hook to measure the width of an element and set the width of another element to match.
 */
const useFitToWidth = ({
  toMeasure,
  targetToChangeRef,
  matchCondition,
  measurementNodeClassName,
  widthBuffer = 0
}) => {
  const measurementRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _a, _b, _c;
    if (!matchCondition) return;
    if (measurementRef.current && targetToChangeRef.current) {
      if (toMeasure) {
        const width = Math.max(
        // Add a small buffer to prevent text from being too tight
        // 2px margin + 8px padding on each side = 20px buffer
        (((_a = measurementRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) + widthBuffer);
        if ((_b = targetToChangeRef.current) === null || _b === void 0 ? void 0 : _b.style) {
          // eslint-disable-next-line no-param-reassign
          targetToChangeRef.current.style.width = `${width}px`;
        }
      } else if ((_c = targetToChangeRef.current) === null || _c === void 0 ? void 0 : _c.style) {
        // eslint-disable-next-line no-param-reassign
        targetToChangeRef.current.style.width = `${widthBuffer}px`;
      }
    }
  }, [toMeasure, matchCondition]);
  if (!matchCondition) return {
    measurementNode: null
  };
  return {
    measurementNode: (/*#__PURE__*/_react.default.createElement("div", {
      ref: measurementRef,
      "aria-hidden": "true",
      className: measurementNodeClassName
    }, toMeasure))
  };
};
exports.useFitToWidth = useFitToWidth;